import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NUMBER_400 } from '~shared/constants';
import { animate, state, style, transition, trigger } from '@angular/animations';

enum OVERLAY_ANIMATIONS {
  OPEN = 'open',
  CLOSE = 'close',
}

@Component({
  selector: 'app-sponsoring-overlay',
  templateUrl: './sponsoring-overlay.component.html',
  styleUrls: ['./sponsoring-overlay.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        OVERLAY_ANIMATIONS.OPEN,
        style({
          bottom: '-55%',
        })
      ),
      state(
        OVERLAY_ANIMATIONS.CLOSE,
        style({
          bottom: '-100%',
        })
      ),
      transition('* => *', [animate('0.3s')]),
    ]),
  ],
})
export class SponsoringOverlayComponent implements OnInit, OnDestroy {
  @Input() width: string;
  @Input() isMobile: boolean;
  @Output() closeSidebar: EventEmitter<void> = new EventEmitter<void>();

  isOpen: boolean = true;
  animationState: string;
  openAnimationState: OVERLAY_ANIMATIONS;

  ngOnInit(): void {
    this.setHiddenOverflow();
    this.setSidebarState();
  }

  ngOnDestroy(): void {
    document.getElementsByTagName('html')[0].style.overflow = 'auto';
  }

  private setHiddenOverflow(): void {
    document.getElementsByTagName('html')[0].style.overflow = 'hidden';
  }

  private setSidebarState(): void {
    if (this.isOpen) {
      this.openAnimationState = OVERLAY_ANIMATIONS.OPEN;
    } else {
      this.openAnimationState = OVERLAY_ANIMATIONS.CLOSE;
    }
  }

  onClose(): void {
    this.isOpen = false;
    this.setSidebarState();

    setTimeout(() => {
      this.closeSidebar.emit();
    }, NUMBER_400);
  }
}
